import React, {useEffect, useState} from 'react';
import './_club-competition-tile.scss';
import {useSelector} from 'react-redux';
import {RootState} from '../../../store/configureStore';

const ClubCompetitionTile = (props: any): JSX.Element => {

  const convertDateFormat = (date: any) => {
    const newDate = new Date(date);
    const timezoneDate = newDate.toLocaleString('en-US', {timeZone: timeZone});
    const timeZoneDateObj = new Date(timezoneDate);
    return {
      dateObj: newDate,
      timezoneDate: timeZoneDateObj,
      formattedDate: `${newDate.getDate()} ${newDate.toLocaleString('en-US', {
        timeZone: timeZone,
        month: 'short'
      })} ${newDate.getFullYear()}`,
    };
  }

  const timeZone = useSelector((state: RootState) => state.widgetConfigurationSettings.timeZone);
  const tenant = useSelector((state: RootState) => state.widgetConfigurationSettings.tenant);
  const getSeasonStartDate = props.competitionDetails && props.competitionDetails.seasonOpenDate ? convertDateFormat(props.competitionDetails.seasonOpenDate) : null;
  const getSeasonEndDate = props.competitionDetails && props.competitionDetails.seasonEndDate ? convertDateFormat(props.competitionDetails.seasonEndDate) : null;
  const getRegEndDate = props.competitionDetails && props.competitionDetails.regEndDate ? convertDateFormat(props.competitionDetails.regEndDate) : null;
  const getRegStartDate = props.competitionDetails && props.competitionDetails.regOpenDate ? convertDateFormat(props.competitionDetails.regOpenDate) : null;

  const [isRegistrationAvailable, setIsRegistrationAvailable] = useState(false);
  const registerButtonQueryString = `?utm_source=${tenant}_clubfinder&utm_medium=website&utm_campaign=clubfinder&utm_id=registration`;

  useEffect(() => {
    const regStartDate = getRegStartDate ? getRegStartDate.dateObj : null;
    const regEndDate = getRegEndDate ? getRegEndDate.dateObj : null;
    const userDate = new Date();
    if (regStartDate && regEndDate) {
      if (userDate >= regStartDate && userDate <= regEndDate) {
        setIsRegistrationAvailable(true);
      } else {
        setIsRegistrationAvailable(false);
      }
    }
  }, [getRegStartDate, getRegStartDate?.dateObj, getRegEndDate, getRegEndDate?.dateObj]);


  return (
    <div className={'competitionTileContainer'} key={props.index}>
      <div className={'competitionTileCol'}>
        {props.competitionDetails.name && (
          <div className={'competitionTitle'}>{props.competitionDetails.name}</div>
        )}
        {props.competitionDetails.seasonOpenDate && (
          <div className={'competitionSeasonDate'}>Season
            dates: {getSeasonStartDate?.formattedDate} - {getSeasonEndDate?.formattedDate}</div>
        )}
        {props.competitionDetails.regOpenDate && (
          <div
            className={'competitionRegistrationDate'}>Registration: {getRegStartDate?.formattedDate} - {getRegEndDate?.formattedDate}</div>
        )}
        {props.competitionDetails.regFormURL && props.competitionDetails.regFormVisible && isRegistrationAvailable && (
          <div className={'buttonContainer'}>
            <a href={`${props.competitionDetails.regFormURL}${registerButtonQueryString}`} target='_blank' className={'buttonText'} >
              Register
            </a>
          </div>
        )}
      </div>
      <div className={'competitionLogoContainer'}>
        {props.competitionDetails.logo && (
          <img src={props.competitionDetails.logo} className={'competitionLogoImage'} alt="logo"/>
        )}
      </div>
    </div>
  )
}

export default ClubCompetitionTile;
